<template>
  <v-card v-if="!mapDataLoaded" class="text-lg-center progress-circle">
    <v-progress-circular indeterminate> </v-progress-circular>
  </v-card>
  <v-list two-line v-else>
    <v-text-field
      hide-details
      prepend-icon="search"
      v-show="userPOGs.length > 0"
      class="ma-2"
      dense
      outline
      v-model="pogSearch"
      placeholder="Search for a Project"
    ></v-text-field>
    <div class="text-lg-center">
      <v-btn
        outline
        small
        v-if="user && adminUsers.includes(user.username)"
        @click="showAllPOGs = !showAllPOGs"
        >{{ showAllPOGs ? "Show yours only" : "Show from other users" }}</v-btn
      >
    </div>

    <template>
      <div v-for="(item, index) in userPOGs" :key="index">
        <v-subheader v-if="item.status" :key="item.status">
          {{ item.status }}
        </v-subheader>

        <v-list-tile v-else avatar @click="editPOG(item)">
          <v-list-tile-avatar>
            <v-icon>
              {{ icons[item.type] }}
            </v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title
              v-html="
                `<b>${item.name}</b> - ${item.type} project created on ${item.created}`
              "
            ></v-list-tile-title>
            <v-list-tile-sub-title
              v-html="item.description"
              class="text-truncate"
            ></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider inset></v-divider>
      </div>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "ListPOGS",

  data() {
    return {
      pogSearch: null,
      icons: {
        "Restoration/Enhancement": "rotate_left",
        Conservation: "eco",
        "Awareness/Education": "share",
      },
      showAllPOGs: false,
    };
  },

  computed: {
    user() {
      return this.$store.state.settings.user;
    },
    adminUsers() {
      return this.$store.state.settings.adminUsers;
    },
    pogs() {
      return this.$store.state.map.pogs;
    },
    mapDataLoaded() {
      return this.$store.state.map.dataLoaded;
    },
    userPOGs() {
      if (!this.mapDataLoaded) {
        return [];
      } else {
        let pogs = [];

        this.pogs.forEach((pog) => {
          if (
            this.user &&
            (pog.createdByUser === this.user.username || this.showAllPOGs)
          ) {
            pogs.push(pog);
          }
        });

        if (this.pogSearch) {
          const searchText = this.pogSearch.toLowerCase();

          pogs = pogs.filter((pog) => {
            return pog.name.toLowerCase().includes(searchText);
          });
        }

        if (pogs.length === 0) {
          pogs = [
            {
              status: "No Projects",
            },
          ];
        }

        return pogs;
      }
    },
  },

  methods: {
    editPOG(pog) {
      this.$emit("edit-pog", pog);
    },
  },
};
</script>

<style scoped>
.progress-circle {
  padding: 20px;
}
</style>
